import { z } from 'zod';

export const signOfferResponseSchema = z.object({
  orderId: z.string(),
  autoStartToken: z.string()
});

export const acceptOfferResponseSchema = z.object({
  agreementId: z.string()
});

export const withdrawalStatusResponseSchema = z.discriminatedUnion('status', [
  z.object({
    status: z.enum(['INITIATED', 'RETRYING', 'FAILED'])
  }),
  z.object({
    status: z.literal('SUCCESS'),
    transactionId: z.string()
  })
]);
